module.exports = __webpack_public_path__ + "static/media/heat_bad.b4172b71.svg";